import React from "react";
const SvgPoiSchoolMiddle = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#0981F9"
        d="M24 12c0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12S5.372 0 12 0c6.627 0 12 5.373 12 12"
      />
      <path
        fill="#FFF"
        d="M8.746 12.058h6.508v-1.68H8.746v1.68zm8.845.002h-1.523v-1.738a1.571 1.571 0 001.174-1.515V5.572c0-.866-.704-1.572-1.571-1.572H8.329c-.867 0-1.571.706-1.571 1.572v3.235c0 .728.499 1.337 1.172 1.514v1.739H6.407a.409.409 0 00-.407.409v1.474c0 .226.183.407.407.407h.535v4.306c0 .226.182.409.407.409h1.312a.41.41 0 00.409-.409V14.35h5.779v4.39c0 .225.183.406.409.406h1.391a.406.406 0 00.407-.407V14.35h.535a.407.407 0 00.409-.407V12.47a.408.408 0 00-.409-.409z"
      />
    </g>
  </svg>
);
export default SvgPoiSchoolMiddle;
